<template>
  <form class="dropzone dz-avatar">
    <font-awesome-icon class="close" :icon="['fas', 'times-circle']" @click.stop="removeAllFiles" v-if="isUpload"/>
    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <div id="dropzone-message" style="display: none">
      <span class="dropzone-title">
        <font-awesome-icon :icon="['fas', 'image']" />
      </span>
      <span class="dropzone-info">
        ファイルをドロップダウン<br>
        またはクリックでファイル選択
      </span>
    </div>
  </form>
</template>

<script>
import Dropzone from 'dropzone'
import '../../../node_modules/dropzone/dist/dropzone.css'
import apig from '@/apig'
import store from '@/store'

Dropzone.autoDiscover = false

export default {
  name: 'dropzone_grader',
  computed: {
    api () {
      return store.getters.api
    }
  },
  data () {
    return {
      isUpload: false
    }
  },
  methods: {
    removeAllFiles () {
      this.dropzone.removeAllFiles()
      this.isUpload = false
      this.$emit('data', {
        isUpload: this.isUpload
      })
    }
  },
  mounted () {
    const vm = this

    let options = {
      // The URL will be changed for each new file being processing
      url: '/',

      // Since we're going to do a `PUT` upload to S3 directly
      method: 'put',

      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending (file, xhr) {
        let _send = xhr.send
        xhr.send = () => {
          _send.call(xhr, file)
        }
      },

      maxFiles: 1,
      dictMaxFilesExceeded: 'アップロードは1ファイルのみです',
      acceptedFiles: 'image/*',
      dictInvalidFileType: 'アップロードは画像ファイルのみです',
      maxFilesize: 3.0,
      dictFileTooBig: 'アップロードは3MBまでです。',

      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: '',

      // Customize the wording
      dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML,

      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,

      // Here we request a signed upload URL when a file being accepted
      accept (file, done) {
        let additionalParams = {
          queryParams: {
            type: 'grader'
          }
        }
        apig.getSignedURL(file, additionalParams)
          .then((res) => {
            file.uploadURL = res.data.url
            done()

            setTimeout(() => {
              vm.dropzone.processFile(file)

              vm.isUpload = true
              vm.$emit('data', {
                isUpload: vm.isUpload,
                avatarId: res.data.uuid
              })
            })
          })
          .catch((err) => {
            console.log(err)
            done('アップロードに失敗しました', err)
          })
      }
    }

    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, options)

    // Set signed upload URL for each file
    vm.dropzone.on('processing', (file) => {
      vm.dropzone.options.url = file.uploadURL
    })
  }
}
</script>

<style lang="stylus" scoped>
primaryBlue = #3498db

.dropzone
  padding 0

.dz-avatar
  height 250px!important
  width 250px!important

form.dropzone
  transition all 0.2s linear
  border 2px dashed #ccc
  background-color #fafafa
  min-height initial
  &:hover
    border-color primaryBlue
    .dz-message
      .dropzone-title
        color primaryBlue
  .dz-message
    color #666
    display -webkit-flex
    display flex
    -webkit-align-items center
    align-items center
    -webkit-justify-content center
    justify-content center
    span
      line-height 1.8
      font-size 13px
      letter-spacing 0.4px
      span.dropzone-title
        display block
        color #888
        font-size 90px
      span.dropzone-info
        display block
        color #a8a8a8

</style>



// WEBPACK FOOTER //
// src/components/share/dropzone_grader.vue